export const categories = [
  {
    slug: 'all',
    name: '全部平台',
    description: '浏览所有推荐的原创内容发布平台',
    icon: 'ri-apps-line',
  },
  {
    slug: 'novel',
    name: '小说创作',
    description: '适合长篇小说、连载故事的发布平台',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'blog',
    name: '博客写作',
    description: '适合个人博客、技术文章的平台',
    icon: 'ri-article-line',
  },
  {
    slug: 'social',
    name: '社交媒体',
    description: '适合短篇内容、图文分享的平台',
    icon: 'ri-chat-3-line',
  },
  {
    slug: 'professional',
    name: '专业写作',
    description: '适合深度长文、行业分析的平台',
    icon: 'ri-pen-nib-line',
  },
  {
    slug: 'free',
    name: '免费平台',
    description: '零成本开启创作的免费发布平台',
    icon: 'ri-gift-line',
  },
];

export const platforms = [
  {
    id: 1,
    name: '晋江文学城',
    slug: 'jjwxc',
    category: 'novel',
    description: '国内最大的女性向原创文学网站，拥有海量读者群体，特别适合言情、耽美、同人等类型的小说创作。平台提供完善的签约体系和丰厚的作者福利，是众多网络作家起步的首选平台。',
    features: ['女性向文学首选', '读者群体庞大', '签约体系完善', '版权开发成熟'],
    rating: 4.8,
    ratingCount: 12580,
    pricing: '免费发布，签约后有稿费',
    difficulty: '简单',
    url: 'https://www.jjwxc.net',
    imageSeq: 'jjwxc-platform',
    imageQuery: 'Warm%20literary%20atmosphere%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20elegant%20books%20and%20manuscript%20paper%20on%20a%20wooden%20desk%2C%20gentle%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20feminine%20and%20dreamy%20aesthetic%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field',
    pros: ['女性向内容的第一大平台', '读者粘性极高', 'IP改编机会多'],
    cons: ['审核机制较严格', '新作者积累读者需要时间'],
  },
  {
    id: 2,
    name: '起点中文网',
    slug: 'qidian',
    category: 'novel',
    description: '国内最大的男性向原创文学平台，隶属于阅文集团。以玄幻、都市、仙侠等类型见长，拥有成熟的付费阅读体系和作家培养计划，是商业网文写作的标杆平台。',
    features: ['男性向文学标杆', '付费体系成熟', '作家福利优厚', 'IP全版权运营'],
    rating: 4.7,
    ratingCount: 15620,
    pricing: '免费发布，签约后有稿费+分成',
    difficulty: '中等',
    url: 'https://www.qidian.com',
    imageSeq: 'qidian-platform',
    imageQuery: 'Modern%20dark%20themed%20study%20room%2C%20rich%20mahogany%20wood%20tones%2C%20dramatic%20lighting%20from%20a%20desk%20lamp%2C%20ancient%20scroll%20motifs%20blended%20with%20modern%20design%20elements%2C%20masculine%20and%20epic%20atmosphere%2C%20cinematic%20photography%20style',
    pros: ['读者付费意愿强', '全勤奖等福利丰厚', '编辑指导专业'],
    cons: ['竞争激烈', '日更需要较高频率'],
  },
  {
    id: 3,
    name: '知乎',
    slug: 'zhihu',
    category: 'social',
    description: '国内领先的问答社区和内容平台，适合发布深度思考、专业见解、故事创作等内容。盐选专栏为创作者提供了变现渠道，优质内容可以获得可观的流量和收入。',
    features: ['流量巨大', '盐选专栏变现', '领域广泛', '社区互动性强'],
    rating: 4.5,
    ratingCount: 28900,
    pricing: '免费发布，盐选专栏可付费',
    difficulty: '简单',
    url: 'https://www.zhihu.com',
    imageSeq: 'zhihu-platform',
    imageQuery: 'Clean%20minimalist%20workspace%20with%20laptop%20and%20notebook%2C%20neutral%20beige%20and%20white%20color%20scheme%2C%20natural%20daylight%2C%20organized%20desk%20with%20a%20coffee%20cup%2C%20modern%20editorial%20photography%2C%20calm%20and%20professional%20vibe',
    pros: ['流量曝光极高', '变现路径清晰', '社区氛围好'],
    cons: ['算法推荐不稳定', '内容审核严格'],
  },
  {
    id: 4,
    name: '简书',
    slug: 'jianshu',
    category: 'blog',
    description: '一个优质的创作社区，界面简洁优雅，适合写作爱好者记录生活、分享思考。简书提供专题收录和推荐机制，帮助优质内容获得更多曝光。',
    features: ['界面简洁优雅', 'Markdown支持', '专题收录机制', '创作社区氛围好'],
    rating: 4.3,
    ratingCount: 8920,
    pricing: '免费发布',
    difficulty: '非常简单',
    url: 'https://www.jianshu.com',
    imageSeq: 'jianshu-platform',
    imageQuery: 'Serene%20minimal%20writing%20space%2C%20white%20desk%20with%20a%20simple%20notebook%20and%20pen%2C%20green%20plant%20in%20the%20corner%2C%20soft%20diffused%20lighting%2C%20Japanese%20zen%20aesthetic%2C%20clean%20composition%2C%20editorial%20style',
    pros: ['上手门槛极低', '社区友善', '写作体验流畅'],
    cons: ['变现能力较弱', '用户增长放缓'],
  },
  {
    id: 5,
    name: '微信公众号',
    slug: 'wechat-mp',
    category: 'blog',
    description: '微信生态内的内容创作平台，拥有超过12亿的用户基础。适合建立个人品牌、运营粉丝社群，通过广告、付费阅读、打赏等方式实现多元化变现。',
    features: ['用户基础庞大', '变现方式多样', '粉丝粘性高', '私域流量运营'],
    rating: 4.6,
    ratingCount: 21300,
    pricing: '免费注册，需认证（300元/年）',
    difficulty: '中等',
    url: 'https://mp.weixin.qq.com',
    imageSeq: 'wechat-platform',
    imageQuery: 'Modern%20green%20themed%20digital%20communication%20concept%2C%20smartphone%20displaying%20content%20on%20screen%2C%20light%20emerald%20and%20white%20gradient%20background%2C%20clean%20tech%20aesthetic%2C%20professional%20product%20photography',
    pros: ['用户基数无可匹敌', '变现模式成熟', '社交传播力强'],
    cons: ['需要持续运营', '涨粉初期较难'],
  },
  {
    id: 6,
    name: '豆瓣',
    slug: 'douban',
    category: 'social',
    description: '以书影音为核心的兴趣社区，同时也孕育了大量优质原创内容。豆瓣日记和小组功能让创作者可以找到志同道合的读者，形成深度交流的文化社区。',
    features: ['文化氛围浓厚', '读者质量高', '小组社群活跃', '长尾流量可观'],
    rating: 4.2,
    ratingCount: 15600,
    pricing: '免费发布',
    difficulty: '简单',
    url: 'https://www.douban.com',
    imageSeq: 'douban-platform',
    imageQuery: 'Artistic%20reading%20nook%20with%20vintage%20books%2C%20warm%20amber%20lighting%2C%20retro%20green%20walls%2C%20comfortable%20armchair%2C%20cultural%20and%20intellectual%20atmosphere%2C%20film%20posters%20on%20wall%2C%20cozy%20editorial%20photography',
    pros: ['读者审美水平高', '社区文化独特', '内容长尾效应好'],
    cons: ['商业变现有限', '审核偶有延迟'],
  },
  {
    id: 7,
    name: '番茄小说',
    slug: 'fanqie',
    category: 'free',
    description: '字节跳动旗下的免费阅读平台，主打免费模式+广告分成。创作者可以零门槛入驻，通过读者阅读广告获得收益，是新手作家快速积累读者的好选择。',
    features: ['免费模式', '广告分成', '流量巨大', '新人友好'],
    rating: 4.4,
    ratingCount: 18700,
    pricing: '完全免费，广告分成收益',
    difficulty: '非常简单',
    url: 'https://fanqienovel.com',
    imageSeq: 'fanqie-platform',
    imageQuery: 'Bright%20vibrant%20modern%20creative%20space%2C%20red%20and%20white%20color%20accents%2C%20digital%20tablet%20displaying%20content%2C%20energetic%20and%20youthful%20atmosphere%2C%20clean%20minimal%20design%2C%20editorial%20product%20photography',
    pros: ['零成本入门', '流量推荐给力', '收益模式透明'],
    cons: ['收益依赖阅读量', '内容类型有偏向'],
  },
  {
    id: 8,
    name: 'Lofter',
    slug: 'lofter',
    category: 'social',
    description: '网易旗下的轻博客社区，以二次元、插画、摄影、同人创作为特色。社区氛围年轻活泼，适合视觉化内容创作和兴趣社群运营。',
    features: ['视觉化创作友好', '同人文化浓厚', '兴趣标签体系', '年轻用户为主'],
    rating: 4.1,
    ratingCount: 9800,
    pricing: '免费发布',
    difficulty: '非常简单',
    url: 'https://www.lofter.com',
    imageSeq: 'lofter-platform',
    imageQuery: 'Playful%20creative%20studio%20space%2C%20pastel%20color%20palette%20with%20soft%20pink%20and%20mint%20green%2C%20art%20supplies%20and%20digital%20tablet%2C%20young%20and%20trendy%20atmosphere%2C%20kawaii%20aesthetic%2C%20editorial%20photography',
    pros: ['视觉创作者天堂', '社区互动活跃', '兴趣社群精准'],
    cons: ['纯文字内容曝光较少', '商业化程度低'],
  },
  {
    id: 9,
    name: '今日头条',
    slug: 'toutiao',
    category: 'professional',
    description: '字节跳动旗下的综合资讯平台，通过智能推荐算法为创作者精准匹配读者。青云计划等激励政策为优质内容创作者提供丰厚回报。',
    features: ['智能推荐精准', '激励政策丰富', '多元内容形式', '用户覆盖面广'],
    rating: 4.3,
    ratingCount: 23400,
    pricing: '免费发布，流量分成',
    difficulty: '简单',
    url: 'https://www.toutiao.com',
    imageSeq: 'toutiao-platform',
    imageQuery: 'Contemporary%20newsroom%20style%20workspace%2C%20multiple%20screens%20displaying%20content%2C%20warm%20orange%20and%20red%20accents%2C%20professional%20yet%20approachable%20atmosphere%2C%20modern%20office%20setting%2C%20editorial%20photography',
    pros: ['算法推荐强', '收益透明及时', '支持多形式内容'],
    cons: ['内容同质化严重', '热点依赖度高'],
  },
  {
    id: 10,
    name: 'B站专栏',
    slug: 'bilibili-column',
    category: 'social',
    description: 'Bilibili的图文专栏功能，依托B站庞大的年轻用户群体，特别适合动漫、游戏、科技等领域的深度内容创作。专栏支持富文本编辑，阅读体验流畅。',
    features: ['年轻用户群体', '粉丝转化率高', '专栏+视频联动', '社区文化独特'],
    rating: 4.4,
    ratingCount: 11200,
    pricing: '免费发布',
    difficulty: '简单',
    url: 'https://www.bilibili.com',
    imageSeq: 'bilibili-platform',
    imageQuery: 'Dynamic%20creative%20space%20with%20tech%20gadgets%20and%20anime%20decorations%2C%20blue%20and%20pink%20neon%20accents%2C%20modern%20gaming%20setup%2C%20youthful%20and%20energetic%20vibe%2C%20editorial%20photography%20with%20shallow%20depth',
    pros: ['粉丝粘性极强', '互动氛围好', '跨内容联动'],
    cons: ['偏二次元调性', '图文优先级低于视频'],
  },
  {
    id: 11,
    name: '小红书',
    slug: 'xiaohongshu',
    category: 'social',
    description: '生活方式分享平台，以图文笔记为主。适合美妆、穿搭、旅行、美食等生活方式类内容创作。平台年轻女性用户居多，种草转化能力强。',
    features: ['种草转化强', '图文笔记形式', '社区信任度高', '商业合作机会多'],
    rating: 4.5,
    ratingCount: 32100,
    pricing: '免费发布',
    difficulty: '简单',
    url: 'https://www.xiaohongshu.com',
    imageSeq: 'xiaohongshu-platform',
    imageQuery: 'Stylish%20lifestyle%20flatlay%2C%20beauty%20products%20and%20fashion%20accessories%20on%20marble%20surface%2C%20soft%20rose%20gold%20accents%2C%20natural%20light%20from%20window%2C%20elegant%20and%20aspirational%20aesthetic%2C%20editorial%20product%20photography',
    pros: ['商业价值极高', '用户购买力强', '算法对新人也友好'],
    cons: ['内容趋于同质', '笔记要求图文并茂'],
  },
  {
    id: 12,
    name: 'Medium',
    slug: 'medium',
    category: 'professional',
    description: '全球知名的英文写作平台，也有不少中文创作者。以深度长文和专业知识分享为主，界面极简，阅读体验优秀。Partner Program让创作者可以通过会员阅读获得收益。',
    features: ['国际化平台', '界面极简美观', 'Partner Program', '专业知识社区'],
    rating: 4.6,
    ratingCount: 8900,
    pricing: '免费发布，Partner Program $5/月',
    difficulty: '简单',
    url: 'https://medium.com',
    imageSeq: 'medium-platform',
    imageQuery: 'Sleek%20minimalist%20writing%20environment%2C%20black%20and%20white%20color%20scheme%2C%20MacBook%20on%20a%20clean%20desk%2C%20typography-focused%20design%20elements%2C%20sophisticated%20and%20intellectual%20atmosphere%2C%20editorial%20photography',
    pros: ['设计极简优雅', '国际读者群体', '变现模式清晰'],
    cons: ['中文读者较少', '需要英文辅助'],
  },
];

export const getPlatformBySlug = (slug: string) => platforms.find((p) => p.slug === slug);

export const getPlatformsByCategory = (categorySlug: string) => {
  if (categorySlug === 'all') return platforms;
  return platforms.filter((p) => p.category === categorySlug);
};

export const getRelatedPlatforms = (currentSlug: string, limit: number = 4) => {
  const current = platforms.find((p) => p.slug === currentSlug);
  if (!current) return platforms.slice(0, limit);
  return platforms
    .filter((p) => p.slug !== currentSlug && p.category === current.category)
    .slice(0, limit);
};